import { render, staticRenderFns } from "./TrainingStructureModal.vue?vue&type=template&id=6afd1dd7&scoped=true&"
import script from "./TrainingStructureModal.vue?vue&type=script&lang=js&"
export * from "./TrainingStructureModal.vue?vue&type=script&lang=js&"
import style0 from "./TrainingStructureModal.vue?vue&type=style&index=0&id=6afd1dd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd1dd7",
  null
  
)

export default component.exports